(() => {
  // app/scripts/common/function/linkOptions.js
  var linkOptions = (container, product, cb) => {
    let optionsMap = {};
    if (!container) {
      return;
    }
    let statusWhenVariantSoldOut = container.dataset.status;
    let optionElements = container.getElementsByClassName("js-option-item");
    if (product.variants.length <= 1) {
      return;
    }
    optionElements.addEvents("change", function() {
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: +this.dataset.optionPosition }));
    });
    container.addEvent("swatch-change", function({ detail: position }) {
      switch (position) {
        case 1:
          if (product.options.length > 1) {
            updateOptionsInSelector(2);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 2:
          if (product.options.length === 3) {
            product.options.length === 3 && updateOptionsInSelector(3);
          } else {
            cb(findVariantFromOption(getValueOptions()));
          }
          break;
        case 3:
          cb(findVariantFromOption(getValueOptions()));
          break;
      }
    });
    product.variants.forEach((variant) => {
      if (variant.available) {
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = optionsMap["root"].reduce((accu, currentvalue) => {
          if (!accu.includes(currentvalue)) {
            accu.push(currentvalue);
          }
          return accu;
        }, []);
        if (product.options.length > 1) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = optionsMap[key].reduce((accu, currentvalue) => {
            if (!accu.includes(currentvalue)) {
              accu.push(currentvalue);
            }
            return accu;
          }, []);
        }
      }
    });
    updateOptionsInSelector(1);
    function updateOptionsInSelector(index) {
      if (!Object.keys(optionsMap).length)
        return;
      let setValue = false;
      let optionValues = getValueOptions();
      let key, selector, old_value;
      switch (index) {
        case 1:
          key = "root";
          selector = container.querySelector(".js-swatch-item[data-position='1']");
          break;
        case 2:
          key = optionValues.option1;
          selector = container.querySelector(".js-swatch-item[data-position='2']");
          break;
        case 3:
          key = optionValues.option1 + " / " + optionValues.option2;
          selector = container.querySelector(".js-swatch-item[data-position='3']");
          break;
      }
      switch (selector.dataset.style) {
        case "select": {
          let selectElement = selector.getElementsByClassName("js-option-item")[0];
          let oldValue2 = selectElement.value;
          switch (statusWhenVariantSoldOut) {
            case "hide": {
              selectElement.innerHTML = optionsMap[key].map((optionValue) => `<option value="${optionValue}">${optionValue}</option>`).join("");
              if (optionsMap[key].includes(oldValue2)) {
                selectElement.value = oldValue2;
              }
              break;
            }
            case "disable": {
              [...selectElement.options].forEach((option) => {
                if (optionsMap[key].includes(option.value)) {
                  option.disabled = false;
                } else {
                  option.disabled = true;
                  option.value === oldValue2 && (option.selected = false);
                }
              });
              break;
            }
          }
          break;
        }
        case "color":
        case "button":
          let inputsElement = selector.getElementsByClassName("js-option-item");
          let oldValue = [...inputsElement].find((input) => input.checked).value;
          switch (statusWhenVariantSoldOut) {
            case "hide":
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.parentElement.removeClass("d-none");
                } else {
                  input.parentElement.addClass("d-none");
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            case "disable": {
              inputsElement.forEach((input) => {
                if (optionsMap[key].includes(input.value)) {
                  input.disabled = false;
                } else {
                  input.disabled = true;
                  oldValue === input.value && (input.checked = false, inputsElement[0].checked = true);
                }
              });
              break;
            }
          }
          break;
      }
      container.dispatchEvent(new CustomEvent("swatch-change", { detail: index }));
    }
    function getValueOptions() {
      return [...container.getElementsByClassName("js-swatch-item")].reduce((accu, element) => {
        switch (element.dataset.style) {
          case "select":
            let select = element.querySelector("select.single-option-selector");
            accu[select.name] = select.value;
            break;
          case "color":
          case "image":
          case "button":
            let inputsElements = element.querySelectorAll("input[data-single-option-selector]");
            accu[inputsElements[0].name] = [...inputsElements].find((input) => input.checked).value;
            break;
        }
        return accu;
      }, {});
    }
    function findVariantFromOption(options) {
      return product.variants.find((variant) => {
        return Object.keys(options).every((optionKey) => variant[optionKey] === options[optionKey]);
      });
    }
  };

  // app/scripts/quick-shop.js
  var QuickShopModal = class extends HTMLElement {
    constructor() {
      super();
      const Popup = window.Popup;
      this.modal = new Popup(this);
    }
    renderHTML(html) {
      this.querySelector(".js-modal-content").innerHTML = "";
      this.querySelector(".js-modal-content").innerHTML = html;
      this.initQuickShopEvent();
      this.modal.open();
    }
    initQuickShopEvent() {
      this.product = JSON.parse(this.querySelector("[data-product-json]").innerHTML);
      this.variantsInventory = JSON.parse(this.querySelector("[data-variants-inventory-json]").innerHTML);
      Object.keys(this.variantsInventory).forEach((variantId) => {
        this.product.variants.find((variant) => variant.id == variantId && Object.assign(variant, this.variantsInventory[variantId]));
      });
      this.elms = {
        swatchContainer: this.querySelector(".swatch-list"),
        productWrapperElement: this.querySelector(".js-product-wrapper"),
        priceCompareElement: this.querySelector(".js-compare-at-price"),
        priceElement: this.querySelector(".js-product-price"),
        saleLabelElement: this.querySelector(".js-label_ui-sale"),
        variantAvailableStatus: this.querySelector(".js-product-status"),
        skuElement: this.querySelector(".js-product-sku"),
        mainMediaContainer: this.querySelector(".js-slider-main"),
        thumbnailsMediaContainer: this.querySelector(".js-slider-thumbnails"),
        selectMaster: this.querySelector("#selected_variant_quickshop"),
        inputQuantityContainer: this.querySelector(".js-input-quantity-container"),
        productFormInput: this.querySelector("#product_form_input_quickshop"),
        formElm: this.querySelector(".js-form-add-to-card"),
        buttonAddToCart: this.querySelector(".js-btn-add-to-cart"),
        swatchFormContainer: this.querySelector(".js-swatch-form")
      };
      this.initSlideMedia();
      AT.initInputQuantity(this.elms.inputQuantityContainer);
      !!this.elms.formElm && this.initFormAddToCart(this.elms.formElm);
      linkOptions(this.elms.swatchFormContainer, this.product, this.handleVariantChange.bind(this));
    }
    initFormAddToCart(form) {
      if (!form) {
        return;
      }
      let btnAddToCart = form.querySelector(".btn-add-to-cart");
      form.addEvent("submit", (e) => {
        e.preventDefault();
        btnAddToCart.addClass("pending");
        Cart.add(form).finally(() => {
          this.modal.close();
          btnAddToCart.removeClass("pending");
        });
      });
    }
    initSlideMedia() {
      let { mainMediaContainer, thumbnailsMediaContainer } = this.elms;
      (() => {
        if (!mainMediaContainer) {
          return;
        }
        let configElement = mainMediaContainer.querySelector("[data-tns-config]");
        if (!configElement) {
          return;
        }
        let config = JSON.parse(configElement.innerHTML);
        this.mainSlider = tns(config);
        this.mainSlider.events.on("indexChanged", (info) => {
          info.slideItems.forEach((item) => {
            if (item.querySelector("video")) {
              item.querySelector("video").pause();
            }
          });
          if (info.slideItems[info.index].querySelector("video")) {
            info.slideItems[info.index].querySelector("video").play();
          }
        });
      })();
      (() => {
        if (!thumbnailsMediaContainer) {
          return;
        }
        let config = JSON.parse(thumbnailsMediaContainer.querySelector("[data-tns-config]").innerHTML);
        tns(config);
      })();
    }
    handleVariantChange(variant) {
      let {
        productFormInput,
        productWrapperElement,
        saleLabelElement,
        priceCompareElement,
        priceElement,
        variantAvailableStatus,
        skuElement,
        buttonAddToCart,
        selectMaster
      } = this.elms;
      if (!variant) {
        productWrapperElement.setAttribute("data-status", "out-stock");
        return;
      }
      this.currentVariant = variant;
      this.updateSubscribeForm(variant);
      let saleLabelElementStyle = saleLabelElement.getAttribute("data-style");
      if (typeof Currencies !== "undefined") {
        if (!!variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.removeClass("d-none");
            if (saleLabelElementStyle == "percent") {
              let percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saleLabelElement.innerHTML = "-" + percent + "%";
            }
          }
          priceCompareElement.setAttribute("data-money", variant.compare_at_price);
          priceCompareElement.removeClass("d-none");
        } else {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.addClass("d-none");
          }
          priceCompareElement.addClass("d-none");
        }
        priceElement.setAttribute("data-money", variant.price);
      } else {
        if (!!variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.removeClass("d-none");
            if (saleLabelElementStyle == "percent") {
              let percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saleLabelElement.innerHTML = "-" + percent + "%";
            }
          }
          priceCompareElement.innerHTML = variant.compare_at_price.toCurrency();
          priceCompareElement.removeClass("d-none");
        } else {
          if (saleLabelElementStyle != "none") {
            saleLabelElement.addClass("d-none");
          }
          priceCompareElement.addClass("d-none");
        }
        priceElement.innerHTML = variant.price.toCurrency();
      }
      if (variant.available) {
        if (variant.inventory_management) {
          if (variant.inventory_policy == "continue" && variant.inventory_quantity < 1) {
            productWrapperElement.setAttribute("data-status", "back-order");
            buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.preOrder;
          } else {
            productWrapperElement.setAttribute("data-status", "in-stock");
            buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.addToCart;
          }
          if (variant.inventory_policy == "continue") {
            productFormInput.setAttribute("max", 1e3);
          } else {
            productFormInput.setAttribute("max", variant.inventory_quantity);
          }
        } else {
          productWrapperElement.setAttribute("data-status", "in-stock");
          buttonAddToCart.querySelector(".btn-label").innerHTML = theme.strings.addToCart;
          productFormInput.setAttribute("max", 1e3);
        }
        if (productFormInput.value > Number(productFormInput.getAttribute("max"))) {
          productFormInput.value = Number(productFormInput.getAttribute("max"));
        }
      } else {
        productWrapperElement.setAttribute("data-status", "out-stock");
      }
      if (!!skuElement) {
        !!variant.sku ? (skuElement.innerHTML = variant.sku, skuElement.parentElement.removeClass("d-none")) : skuElement.parentElement.addClass("d-none");
      }
      if (!!variant.featured_image && !!this.mainSlider) {
        this.mainSlider.goTo(variant.featured_image.position - 1);
      }
      selectMaster.value = variant.id;
    }
    updateSubscribeForm(variant) {
      document.querySelector("#btn_pre_order_quickshop").href = window.Shopify.routes.root + `products/${this.product.handle}?variant=${variant.id}`;
    }
    switchVariantById(variantId) {
      let { swatchContainer } = this.elms;
      let variantFound = theme.product.variants.find((i) => i.id == variantId);
      if (!variantFound) {
        return;
      }
      variantFound.options.forEach((option, index) => {
        [...swatchContainer.querySelectorAll(`[name='option${index + 1}']`)].find((element) => {
          switch (element.tagName) {
            case "INPUT":
              element.value == option && (element.checked = true, element.dispatchEvent(new Event("change")));
              break;
            case "SELECT":
              element.value = option;
              element.dispatchEvent(new Event("change"));
              break;
          }
        });
      });
    }
  };
  customElements.define("quick-shop-modal", QuickShopModal);
})();
